import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareLineDryIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.312 2.25c.416 0 .754.338.754.754v17.993a.754.754 0 0 1-.754.753H3.687a.753.753 0 0 1-.753-.753V3.004c0-.416.337-.754.753-.754Zm-.746 3.193c-1.527 1.404-4.269 2.279-7.567 2.279-3.273 0-6.019-.857-7.565-2.24V20.25h15.132ZM19.11 3.75H4.89c1.003 1.335 3.608 2.472 7.109 2.472 3.503 0 6.108-1.137 7.111-2.472Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareLineDryIcon as default };
//# sourceMappingURL=productCareLineDryIcon.js.map
